/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Esignature = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fillRule="evenodd"
      d="M18.82 9.427c.127.326.188.674.18 1.023v3.3A6.1 6.1 0 0113.1 20H12a6.109 6.109 0 01-6-6.27v-6h.68C8.46 7.73 9 9.14 9 11v2c0 1.713 1.086 1.629 1.85 1.57.128-.01.247-.02.35-.02a1.33 1.33 0 001.29-1.157l3.31 3.317a1.25 1.25 0 001.69-.27 1.25 1.25 0 00.27-1.69L12.5 9.5v-.41a1.33 1.33 0 00-1.3-1.36H9.57A2.33 2.33 0 017.3 5.34V5h6.51a2.66 2.66 0 012.59 2.73 2.66 2.66 0 012.42 1.697z"
      clipRule="evenodd"
    />,
    <path
      fillRule="evenodd"
      d="M6.15 3.15L3.05 2 4.2 5.1l2.63 2.633c1.273.06 1.87.886 2.079 2.083L10.8 11.71a1.3 1.3 0 00.026.017L15.8 16.71a1.25 1.25 0 001.69-.27 1.25 1.25 0 00.27-1.69l-4.983-4.974a1.402 1.402 0 00-.017-.026l-2.023-2.02H9.57A2.33 2.33 0 017.3 5.34V5h.703L6.15 3.15z"
      clipRule="evenodd"
      opacity={0.6}
    />,
  );
};

export default Esignature;
